// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1FOHi","inputWrap":"CustomTip_inputWrap__2QezW"};